"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;
var _times = _interopRequireDefault(require("es-toolkit/compat/times"));
var _react = require("react");
var _PaginationStep = require("./PaginationStep");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const Pagination = ({
  autoplay,
  currentSlide,
  instanceRef,
  pagination,
  slidesCount,
  renderPaginationStep
}) => {
  const {
    maxVisibleItems,
    position
  } = pagination ?? {};
  const onPaginationStepClick = (0, _react.useCallback)(slideIndex => instanceRef.current?.moveToIdx(slideIndex), [instanceRef]);
  if (slidesCount < 2 || currentSlide < 0 || currentSlide >= slidesCount) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PaginationRoot, {
    position: position,
    children: (0, _times.default)(slidesCount).map((_, slideIndex) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaginationStep.PaginationStep
    // eslint-disable-next-line react/no-array-index-key -- No other option for passing data to key
    , {
      autoplay: autoplay,
      hidden: (0, _utils.isPaginationStepHidden)({
        currentSlide,
        maxVisibleItems,
        slidesCount,
        slideIndex
      }),
      isActive: slideIndex === currentSlide,
      isNext: (0, _utils.isNextSlide)({
        slidesCount,
        currentSlide,
        maxVisibleItems,
        slideIndex
      }),
      isPrevious: (0, _utils.isPreviousSlide)({
        slidesCount,
        currentSlide,
        maxVisibleItems,
        slideIndex
      }),
      pagination: pagination,
      slideIndex: slideIndex,
      renderPaginationStep: renderPaginationStep,
      onPaginationStepClick: slideIndex === currentSlide ? undefined : onPaginationStepClick
    }, slideIndex))
  });
};
exports.Pagination = Pagination;
